import * as React from "react";

export const PhoneIcon = (props: any) => (
  <svg
    width={56}
    height={56}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#D1FADF" />
    <path
      d="M25.366 26.682a10.555 10.555 0 0 0 3.952 3.952l.884-1.238a1 1 0 0 1 1.294-.296 11.422 11.422 0 0 0 4.583 1.364 1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995A15.51 15.51 0 0 1 34.5 37C25.94 37 19 30.06 19 21.5c0-.538.027-1.072.082-1.602a1 1 0 0 1 .995-.898h4.462a1 1 0 0 1 .997.921 11.422 11.422 0 0 0 1.364 4.583 1 1 0 0 1-.296 1.294l-1.238.884Zm-2.522-.657 1.9-1.357c-.54-1.164-.909-2.4-1.097-3.668H21.01c-.006.166-.009.333-.009.5C21 28.956 27.044 35 34.5 35c.167 0 .334-.003.5-.01v-2.637a13.413 13.413 0 0 1-3.668-1.097l-1.357 1.9a12.445 12.445 0 0 1-1.588-.75l-.058-.033a12.557 12.557 0 0 1-4.702-4.702l-.033-.058a12.445 12.445 0 0 1-.75-1.588Z"
      fill="#333"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#ECFDF3"
      strokeWidth={8}
    />
  </svg>
);
